import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { GlobalStyle } from '../src/Styles/Globalstyle'
import { Provider } from "react-redux";
import { store } from '../src/store/store'
import { SearchDataProvider } from '../src/Context/searchDataContext'
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <SearchDataProvider>
        <BrowserRouter>
          <GlobalStyle />
          <App />

        </BrowserRouter>
      </SearchDataProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
